import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BlogPage = () => {
  const { t, lang } = useLanguage();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/blog`).then((res) => setPosts(res.data || [])).catch(() => {});
  }, []);

  return (
    <main data-testid="blog-page" className="bg-white pt-28 md:pt-36 pb-20">
      <div className="container-page">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-[#FF5A1F] transition"
        >
          <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
          {t.common.back}
        </Link>

        <div className="mt-6 max-w-3xl">
          <span className="chip mb-5">{t.blog.eyebrow}</span>
          <h1 className="font-display font-black text-5xl sm:text-6xl text-navy leading-[1.02]">
            {t.blog.title}
          </h1>
          <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed">
            {t.blog.lead}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((post) => (
            <article
              key={post.id}
              className="group rounded-2xl overflow-hidden border border-border bg-white card-hover"
              data-testid={`blog-page-card-${post.slug}`}
            >
              <Link to={`/blog/${post.slug}`}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={post.image}
                    alt={lang === "fr" ? post.title_fr : post.title_en}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground">
                    <span className="text-[#FF5A1F]">
                      {lang === "fr" ? post.category_fr : post.category_en}
                    </span>
                    <span>·</span>
                    <span>{post.read_time} {t.blog.minRead}</span>
                  </div>
                  <h2 className="mt-3 font-display text-xl font-bold text-navy leading-tight">
                    {lang === "fr" ? post.title_fr : post.title_en}
                  </h2>
                  <p className="mt-3 text-sm text-foreground/70 leading-relaxed line-clamp-3">
                    {lang === "fr" ? post.excerpt_fr : post.excerpt_en}
                  </p>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </main>
  );
};

export default BlogPage;
